<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">异常统计</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="content_top_three ">
                <div class="inside_pages_right_content_top_left ">
                    <el-button  type="primary" plain size="mini" icon="el-icon-top-right">
                        导出
                    </el-button>
                </div>
                <div class="inside_pages_right_content_top_right ">
                    <el-input v-model.trim="requestData.name"  size="mini" placeholder="请输入学生名称"></el-input> &nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="content_center_three">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">

                    <el-table-column prop="name1" label="学生姓名">
                    </el-table-column>

                    <el-table-column prop="name2" label="班级">
                    </el-table-column>

                    <el-table-column prop="name3" label="性别">
                    </el-table-column>

                    <el-table-column prop="name4" label="异常体温（°C）">
                    </el-table-column>

                    <el-table-column prop="date1"  label="检测时间">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDateTwo(rowData.row.date1)}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content_bottom_three">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                name:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:100,
                pages:20,
                list:[
                    {
                        id:123,
                        name1:'学生姓名测试',
                        name2:'班级测试',
                        date1: 1593273599,
                        name3:'性别测试',
                        name4:'异常体温（°C）测试',
                    }, 
                ],
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
        
    },
    created() {},
    mounted() {
    
    }
};
</script>